module.exports = __webpack_public_path__ + "img/dominica.1a0e826.webp";